/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 *
 * NOTICE from the Sentry authors:
 * - Vendored from: https://github.com/open-telemetry/opentelemetry-js-contrib/tree/15ef7506553f631ea4181391e0c5725a56f0d082/packages/instrumentation-hapi
 * - Upstream version: @opentelemetry/instrumentation-hapi@0.64.0
 */
/* eslint-disable */

export enum AttributeNames {
  HAPI_TYPE = 'hapi.type',
  PLUGIN_NAME = 'hapi.plugin.name',
  EXT_TYPE = 'server.ext.type',
}
